import o from "../../format/index.mjs";
import r from "../_lib/convertToFP/index.mjs";
const f = r(o, 2);
export {
  f as default
};
